module.exports = __webpack_public_path__ + "img/Editar-plantilla.408dd0ba.png";